import React from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass'
import ContentBrandModels from '../../../components/ContentBrandModels'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import {
  TabWrapper,
  TabLabel
} from '../../../components/ContentFinanceTabs/components/Tabs'
import typography from '../../../utils/typography'
import buildPath from '../../../../lib/cars/used/path-builder'

const FlexWrapper = styled(Flex)`
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
`

const Container = styled(Flex)`
  justify-content: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.blue_light};
`

const OfferGridWidget = ({ offerItems }) => {
  let hasOffers = false

  offerItems.forEach((item) => {
    hasOffers = item.offers.length > 0 || hasOffers
  })

  return (
    <Container>
      <TabWrapper
        width={[1]}
        mx={'auto'}
        mt={[null, null, typography.rhythm(1)]}
        mb={[typography.rhythm(1), typography.rhythm(2), typography.rhythm(3)]}
      >
        {!hasOffers && (
          <FlexWrapper px={'4.5vh'} py={'4.5vh'}>
            No offers available right now
          </FlexWrapper>
        )}

        <Tabs>
          <TabList>
            {offerItems &&
              offerItems.length &&
              offerItems.map((item, i) => {
                if (item.offers.length) {
                  return (
                    <Tab key={`tab-header-${i}`}>
                      <TabLabel>{item.heading}</TabLabel>
                    </Tab>
                  )
                }
              })}
          </TabList>

          {offerItems &&
            offerItems.length &&
            offerItems.map((item, i) => {
              const offers = (item.offers || [])
                .map((offer) => {
                  let url = ''
                  if (
                    offer.callToActionLink &&
                    (offer.callToActionLink.startsWith('/') ||
                      offer.callToActionLink.startsWith('http'))
                  ) {
                    url = offer.callToActionLink
                  } else if (offer.callToActionLink) {
                    url = '/' + offer.callToActionLink
                  } else if (offer.slug) {
                    url = offer.slug
                  } else {
                    url = '/'
                  }

                  // Handle multiple vehicles per offer
                  if (
                    offer.usedVehicle &&
                    Array.isArray(offer.usedVehicle) &&
                    offer.usedVehicle.length > 0
                  ) {
                    return offer.usedVehicle.map((vehicle) => {
                      const path = buildPath(vehicle.category, vehicle)
                      return {
                        type: offer.type,
                        make: offer.heading,
                        price: offer.sell,
                        brand: vehicle.brand,
                        model: vehicle.model,
                        path: path,
                        image:
                          vehicle.image ||
                          (vehicle.images && vehicle.images[0]) ||
                          offer.images[0],
                        category: offer.model && offer.model.category,
                        offer: true,
                        offerTitle: offer.offerTitle,
                        saleCategory: offer.saleCategory,
                        dialog: {
                          heading: offer.dialogHeading,
                          description: offer.dialogDescription,
                          ctaLabel: offer.dialogCtaLabel,
                          ctaLink: offer.dialogCtaLink,
                          price: offer.dialogPrice
                        },
                        isUsed: true
                      }
                    })
                  }

                  // Handle single vehicle or model offers
                  const make =
                    (offer.make && offer.make.brandName) ||
                    (offer.usedVehicle && offer.usedVehicle.brand)
                  const model =
                    (offer.model && offer.model.name) ||
                    (offer.usedVehicle && offer.usedVehicle.model)

                  return [
                    {
                      type: offer.type,
                      make: offer.heading,
                      price: offer.sell,
                      brand: make,
                      model: model,
                      path: url,
                      image: offer.images[0],
                      category: offer.model && offer.model.category,
                      offer: true,
                      offerTitle: offer.offerTitle,
                      saleCategory: offer.saleCategory,
                      dialog: {
                        heading: offer.dialogHeading,
                        description: offer.dialogDescription,
                        ctaLabel: offer.dialogCtaLabel,
                        ctaLink: offer.dialogCtaLink,
                        price: offer.dialogPrice
                      }
                    }
                  ]
                })
                .flat() // Flatten the array of arrays into a single array of offers

              if (offers.length) {
                return (
                  <TabPanel key={`tab-area-${i}`}>
                    <FlexWrapper flexWrap="wrap">
                      <ContentBrandModels
                        models={offers}
                        enableFilters
                        enableDialog
                        isOffers
                      />
                    </FlexWrapper>
                  </TabPanel>
                )
              }
            })}
        </Tabs>
      </TabWrapper>
    </Container>
  )
}

export default OfferGridWidget
